import { useEffect, useState } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import {
  mergePresenceState,
  subscribePresenceList,
  type PresencePayload,
} from '../services/messaging/presenceService';

/**
 * Lit la liste de présence en s'abonnant à l'emitter interne du presenceService.
 * Ne joint PAS le canal Realtime lui-même — c'est PresenceBroadcast (monté dans
 * MainLayout) qui gère le subscribe unique. Évite l'erreur "cannot add presence
 * callbacks after subscribe()".
 *
 * À n'instancier que quand le sidecar est ouvert (économie de re-renders).
 */
export function usePresence(): PresencePayload[] {
  const selfId = useAuthStore((s) => s.collaborator?.id ?? null);
  const [list, setList] = useState<PresencePayload[]>([]);

  useEffect(() => {
    const unsubscribe = subscribePresenceList((state) => {
      setList(mergePresenceState(state, selfId));
    });
    return unsubscribe;
  }, [selfId]);

  return list;
}
